import useAttendance from 'v3/pages/ControlTower/Kanban/Attendance/useAttendance';
import AttendanceNotice from 'v3/pages/ControlTower/Kanban/Attendance/Notice';
import React, { useEffect, useMemo, useRef, useState, useContext, useCallback } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { validatePermission } from 'actions/index';
import useModal from 'hooks/useModal';
import Text from 'v3/components/Text';
import Modal from 'v3/components/Modal';
import { useSnackbar } from 'v3/components/Snackbar';
import Button from 'v3/components/Button';
import ApplicationLayout from 'v3/layouts/Application';
import { useCurrentUser, usePermission } from 'hooks';
import { getRate } from 'v3/utils/rate';
import { cooperplaceApi } from 'services/api';
import moment from 'moment';
import { currencyOptions, normalizePhoneBrasil } from 'v3/utils/formatter';
import { DELIVERY_TYPE_OPTIONS } from 'v3/utils/constants';
import { RegisterLoadGRO } from 'v3/pages/LoadGRO/Register';
import { InsuranceValueContextProvider, useInsuranceValue } from 'contexts/InsuranceValueContext';
import TravelRouteCard from 'v3/components/TravelRouteCard';
import { insertWaypointsIntoPoints, normalizeWaypoints, } from 'v3/components/TravelRouteCard/utils/points';
import { getRouteWaypointsFromPoints } from 'v3/components/TravelRouteCard/utils/routeMachineCard';
import LoadData from './LoadData';
import Monitoring from './Monitoring';
import Vehicle from './Vehicle';
import Automations from './Automations';
import RouteModal from './Route';
import { LoadContext, fetchCountries, handleCreation, preLoadNegotiator } from './controller';
import { BlockedTravelContext } from 'contexts/BlockedTravelProvider';
import { loadReplacementToFreightData, loadToFreightData, } from 'v3/components/FreightValues/utils';
import * as Styled from './styled';
import { AttemptRegisterLoad } from '../Modals/attemptRegisterLoad';
import FreightValues from './FreightValues';
const [AddLoadProvider] = LoadContext;

function LoadRegister() {
  usePermission('CADASTRAR_CARGAS', { redirect: true });

  const {
    setMargins,
    fetchBusinessMarginsValues,
    shippingServiceLevelMapped,
    updateItensToFetchMargin
  } = useContext(BlockedTravelContext);

  const hasPermissionToCreate = validatePermission('CADASTRAR_CARGAS');
  const snackbar = useSnackbar();
  const [loadingRate, setLoadingRate] = useState(false);
  const [rateResponse, setRateResponse] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const routeModal = useModal();
  const freightValuesRef = useRef(null);
  const freightValuesReplaceRef = useRef(null);
  const attemptRegisterLoadModal = useModal();
  const [showRouteErrors, setShowRouteErrors] = useState(false);
  const [resetRouteTrigger, setResetRouteTrigger] = useState(0);
  const [destinationsError, setDestinationsError] = useState({});
  const { updateInsuranceValue, loading: insuranceBennerLoading } = useInsuranceValue();
  const [data, setData] = useState({
    showDailyRate: false,
    selectedVehicles: [],
    selectedBodies: [],
    negotiator: [],
    crts: [],
  });
  const [errors, setErrors] = useState({});
  const [clientCardToggle, setClientCardToggle] = useState(true);
  const [inputsCardToggle, setInputsCardToggle] = useState(false);
  const [negotiatedCardToggle, setNegotiatedCardToggle] = useState(false);
  const [discountsCardToggle, setDiscountsCardToggle] = useState(false);
  const [transferCardToggle, setTransferCardToggle] = useState(false);
  const [extraFields, setExtraFields] = useState([]);
  const [inputsExtraFields, setInputsExtraFields] = useState([]);
  const [discountsExtraFields, setDiscountsExtraFields] = useState([]);
  const [transferExtraFields, setTransferExtraFields] = useState([]);
  const [clientAutomations, setClientAutomations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingGro, setLoadingGro] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [registeredLoad, setRegisteredLoad] = useState('');
  const [countryList, setCountryList] = useState([]);
  const [retrievingLoadData, setRetrievingLoadData] = useState(false);
  const [isPreLoad, setIsPreLoad] = useState(false);
  const [freightValuesInitiated, setFreightValuesInitiated] = useState(false);
  const [tollsPlazaInfos, setTollsPlazaInfos] = useState();
  const [dueDate, setDueDate] = useState(
    moment().add(1, 'day').format('DD/MM/YYYY HH:mm')
  );
  const [searchDriver, setSearchDriver] = useState(true);
  const [operationOptions, setOperationOptions] = useState([]);
  const params = useParams();
  const attendance = useAttendance(params.id, 'PRE_LOAD', { enforceAccess: Boolean(params.id) });
  const currentUser = useCurrentUser();

  const [loadingDuplicate, setLoadingDuplicate] = useState(params?.clone_id ? true : false);

  const isPreloadWithGRO = useMemo(
    () => isPreLoad && operationOptions.length > 0,
    [isPreLoad, operationOptions],
  );

  const defaultCountry = {
    id: 1,
    name: 'Brasil',
    abbreviation: 'br',
    ddi: 55,
  };

  const getRouteDateErrors = useCallback((errorList = {}) => {
    return Object.entries(errorList || {}).reduce((acc, [path, message]) => {
      if (!message || !String(message).toLowerCase().includes('data')) return acc;

      const originField = path.match(/^origin\.(start_schedule|scheduled_time)$/);
      if (originField) {
        acc[`origin.${originField[1]}`] = message;
        return acc;
      }

      if (path === 'origin') {
        acc['origin.start_schedule'] = message;
        acc['origin.scheduled_time'] = message;
        return acc;
      }

      const destinationField = path.match(/^destinations\[(\d+)\]\.(start_schedule|scheduled_time)$/);
      if (destinationField) {
        acc[`${destinationField[1]}.${destinationField[2]}`] = message;
        return acc;
      }

      const destination = path.match(/^destinations\[(\d+)\]$/);
      if (destination) {
        acc[`${destination[1]}.start_schedule`] = message;
        acc[`${destination[1]}.scheduled_time`] = message;
      }

      return acc;
    }, {});
  }, []);

  const setErrorsWithRouteDateErrors = useCallback((nextErrors) => {
    if (typeof nextErrors !== 'function') {
      setDestinationsError(getRouteDateErrors(nextErrors));
      setErrors(nextErrors);
      return;
    }

    setErrors(prevErrors => {
      const resolvedErrors = nextErrors(prevErrors);

      setDestinationsError(getRouteDateErrors(resolvedErrors));
      return resolvedErrors;
    });
  }, [getRouteDateErrors]);

  const clearRouteDateErrors = useCallback(() => {
    setDestinationsError({});
    setErrors(old => {
      const nextErrors = { ...(old || {}) };

      Object.entries(nextErrors).forEach(([key, message]) => {
        const isRouteDateField =
          /^origin\.(start_schedule|scheduled_time)$/.test(key) ||
          /^destinations\[\d+\]\.(start_schedule|scheduled_time)$/.test(key) ||
          ((key === 'origin' || /^destinations\[\d+\]$/.test(key)) &&
            String(message || '').toLowerCase().includes('data'));

        if (isRouteDateField) {
          delete nextErrors[key];
        }
      });

      return nextErrors;
    });
  }, []);

  const onChangeAddress = useCallback(({ origin, destinations, polyline, polylineWaypoints }) => {
    clearRouteDateErrors();

    setData((prev) => ({
      ...prev,
      origin: origin,
      destinations: destinations,
      polylineRoute: polyline,
      polylineWaypoints,
    }));
  }, [clearRouteDateErrors]);

  const onChangeRoute = useCallback(({ polyline, polylineWaypoints }) => {
    setData((prev) => ({
      ...prev,
      polylineRoute: polyline,
      polylineWaypoints:
        polylineWaypoints === undefined
          ? prev.polylineWaypoints
          : polylineWaypoints,
    }));
  }, []);

  const onSaveMachineRoute = useCallback((updatedPoints = [], { polylineRoute, totalDistanceInKm } = {}) => {
    clearRouteDateErrors();

    if (!Array.isArray(updatedPoints) || updatedPoints.length === 0) {
      setData(prev => ({
        ...prev,
        origin: null,
        destinations: [],
        polylineRoute: null,
        polylineWaypoints: null,
        totalDistanceInKm: 0,
      }));
      return;
    }

    const normalizedPoints = updatedPoints.filter(Boolean);
    const businessPoints = normalizedPoints.filter(
      point => point?.type?.id !== 'via' && point?.action?.id !== 'via',
    );

    if (businessPoints.length < 2) {
      setData(prev => ({
        ...prev,
        origin: businessPoints[0] || null,
        destinations: [],
        polylineRoute: null,
        polylineWaypoints: null,
        totalDistanceInKm: 0,
      }));
      return;
    }

    const [origin, ...destinations] = businessPoints;

    const nextWaypoints = getRouteWaypointsFromPoints(normalizedPoints);

    setData(prev => ({
      ...prev,
      origin: origin || null,
      destinations: destinations || [],
      polylineRoute: polylineRoute || null,
      polylineWaypoints: nextWaypoints,
      totalDistanceInKm: totalDistanceInKm || 0,
    }));
  }, [clearRouteDateErrors]);

  const points = useMemo(() => {
    const basePoints = [];
    if (data?.origin?.lat && data?.origin?.lng) {
      basePoints.push(data?.origin);
    }

    if (data?.destinations?.length > 0) {
      basePoints.push(
        ...data.destinations.filter(dest => dest?.lat && dest?.lng),
      );
    }

    const waypoints = normalizeWaypoints(data?.polylineWaypoints);
    return insertWaypointsIntoPoints(basePoints, waypoints, {
      defaultCountry,
    });
  }, [data.origin, data.destinations, data.polylineWaypoints]);

  async function handleGetRate(currencyValue) {
    setLoadingRate(true);
    const response = await getRate(currencyValue);

    if (!response.error && response.outdate) {
      snackbar.show(<Text>O valor do dólar informado pode não refletir a cotação atual de mercado. Recomendamos confirmar a taxa antes de realizar qualquer operação.</Text>, {
        type: 'warning',
        duration: 10000,
      });
    }

    if (!response.error) {
      setRateResponse(response);
    } else {
      snackbar.show(<Text>{response.message}</Text>, {
        type: 'error',
      });
    }
    setLoadingRate(false);
  }

  async function initFreightValues({ rate, currency, customData = {} }) {
    const exchangeDay = String(rate?.buy || 0).padEnd(6, '0');
    await freightValuesRef?.current?.init({
      exchangeDay,
      freightExchange: exchangeDay,
      cargoValue: data?.cargoValue,
      rateResponse: rate,
      currency: currency || currencyOptions[0],
      customData,
    });
    await freightValuesReplaceRef?.current?.init({
      exchangeDay,
      freightExchange: exchangeDay,
      cargoValue: data?.cargoValue,
      rateResponse: rate,
      currency: currency || currencyOptions[0],
      customData,
    });
    setFreightValuesInitiated(true);
  }

  async function setFreightValuesDuplicateLoad(loadData, rateResponse) {
    const props = loadToFreightData(loadData, loadData?.travel);

    const exchangeDay = String(rateResponse?.buy || 0).padEnd(6, '0');

    props.freightExchange = exchangeDay
    props.exchangeDay = exchangeDay
    props.customData.shipmentTransfers.pcpObservation = null

    await freightValuesRef.current?.init({
      ...props,
      rateResponse
    });

    if (loadData?.isReplacement && loadData?.replacements.length > 0) {
      const replacementProps = loadReplacementToFreightData(
        loadData,
        loadData?.travel
      );
      replacementProps.freightExchange = exchangeDay
      replacementProps.exchangeDay = exchangeDay
      replacementProps.customData.shipmentTransfers.pcpObservation = null

      await freightValuesReplaceRef.current?.init({
        ...replacementProps,
        rateResponse,
      });
    }
  }

  async function checkPreLoadAttendPermission() {
    const permission = validatePermission('ATENDER_PRECARGA');
    return permission;
  }

  const payloadGro = (loadData, isGro) => {
    const PHONE_MATCHER = /^\+?(\d{2,3})/;
    const [, ddi,] = loadData?.contactInfo?.split(PHONE_MATCHER);
    const country = countryList.find(country => country?.ddi == ddi);

    if (isGro) {
      return {
        country: country || defaultCountry,
        policy: loadData?.loadPolicy?.policy,
        policyProductId: loadData?.loadPolicy?.policyProductId,
        replacements: loadData?.replacements,
        travel: loadData?.travel,
        vehicleTypes: loadData?.vehicleTypes?.map(item => ({
          id: item?.id,
          name: item?.name,
          qtyAxes: item?.qtyAxes,
          qtyPlates: item?.qtyPlates,
        })),
        vehicleImplements: loadData?.vehicleImplementTypes,
        vehicleBodies: loadData?.vehicleBodyTypes,
        operation: {
          ...loadData?.loadPolicy?.operation,
          policy: loadData?.loadPolicy?.policy,
        }
      }
    }
  }

  const duplicateLoad = async (loadId, rateResponse) => {
    try {
      setLoading(true);
      setLoadingDuplicate(true);
      setErrors({});
      const isGro = location?.pathname?.includes('gro');
      const { data: loadData } = await cooperplaceApi.get(`loads/${loadId}`);

      if (loadData.travel) {
        await fetchBusinessMarginsValues(
          loadData?.costCenter?.businessId
        );

        const [marginValue, advanceValue] = shippingServiceLevelMapped(
          loadData?.travel?.shipper?.shippingCompany
            ?.descriptionServiceLevel
        )

        setMargins({
          advance_money_percentage_external:
            loadData?.advanceMoneyPercentageExternal || advanceValue,
          benner_margin: loadData?.travel?.benner_margin || marginValue,
        });
      }

      await updateItensToFetchMargin({
        loadId: loadData?.id,
        mainVehicle: loadData?.travel?.vehicle?.[0]?.vehicles || null,
        origin: loadData?.loadOrigins[0],
        destinations: loadData?.loadDestinations,
        shippingCompany: loadData?.travel?.shipper?.shippingCompany,
      });

      const takerCurrency = currencyOptions.find(
        item => item.value === loadData?.currency
      );
      setData(old => ({
        ...old,
        ...loadData,
        preLoadId: loadData?.id,
        client: {
          id: loadData?.taker?.id,
          social_name: loadData?.taker?.socialName,
          cgccpf: loadData?.taker?.cpfCnpj,
          label: `${loadData?.taker?.socialName} - ${loadData?.taker?.cpfCnpj}`,
          type: loadData?.taker?.type,
        },
        negotiator: loadData?.negotiators?.map(neg => {
          return {
            id: neg?.id,
            username: neg?.username,
            email: neg?.email,
          }
        }) || [],
        phone: normalizePhoneBrasil(loadData?.contactInfo),
        taker_value: loadData?.takerValue,
        total_taker_value: loadData?.totalTakerValue,
        branchOffice: loadData?.branchOffice,
        selectedVehicles: loadData?.vehicleTypes?.map(item => ({
          id: item?.id,
          name: item?.name,
          qty_axes: item?.qtyAxes,
          qty_plates: item?.qtyPlates,
        })),
        selectedBodies: loadData?.vehicleBodyTypes?.map(item => ({
          id: item?.id,
          name: item?.name,
        })),
        selectedImplements: loadData?.vehicleImplementTypes?.map(item => ({
          id: item?.id,
          name: item?.name,
        })),
        costCenter: {
          id: loadData?.costCenter?.id,
          name: loadData?.costCenter?.name,
          business_id: loadData?.costCenter?.businessId,
          external_id: loadData?.costCenter?.externalId,
        },
        cargoValue: loadData?.cargoValue,
        maxTemperature: loadData?.temperature,
        minTemperature: loadData?.temperatureMin,
        dueDate: isGro ? moment().add(1, 'days').format('YYYY-MM-DDTHH:mm') : moment(loadData?.dueDate, 'YYYY/MM/DDTHH:mm').format('DD/MM/YYYY HH:mm'),
        product: loadData?.product,
        currency: takerCurrency,
        selectedDisposition: loadData?.disposition,
        weight: loadData?.loadWeight,
        origin: enrichPointForRouteMap(loadData?.loadOrigins[0], 'collect'),
        destinations: loadData?.loadDestinations?.map(dest =>
          enrichPointForRouteMap(dest, dest.action),
        ),
        tags: loadData?.tags,
        automations: loadData?.automations,
        crt: loadData?.crt,
        crts: loadData?.crts,
        palletNumber: loadData?.palletNumber,
        netWeight: loadData?.netWeight,
        loadVolume: loadData?.loadVolume,
        mopp: loadData?.mopp,
        container: loadData?.container,
        isEscorted: loadData?.isEscorted,
        riskManagers: loadData?.riskManagers,
        tracking: loadData?.riskManagers?.length > 0 ? true : false,
        isReplacement: loadData?.isReplacement,
        loadPublish: loadData?.loadPublish,
        searchDriverRadius: loadData?.searchDriverRadius ? loadData?.searchDriverRadius : '0',
        searchDriver: isGro ? loadData?.searchDriver == 1 ? false : true : loadData?.searchDriver == 1 ? true : false,
        negotiation: loadData?.negotiation,
        polylineRoute: loadData?.polylineRoute,
        polylineWaypoints: loadData?.polylineWaypoints,
        volume: loadData?.loadVolume,
        clientOrderNumber: '',
        externalInvoiceNumber: '',
        observations: '',
        totalDistanceInKm: loadData?.totalDistanceInKm,
        ...payloadGro(loadData, isGro)
      }));

      setDueDate(moment(new Date()).add(1, 'days').format('DD/MM/YYYY HH:mm'));

      await setFreightValuesDuplicateLoad(loadData, rateResponse);

    } catch {
      snackbar.show(<Text>Erro ao recuperar informações da carga</Text>, {
        type: 'error',
      });
    } finally {
      setLoading(false);
      setLoadingDuplicate(false);
    }
  }

  async function handleFetchLoad(loadId, rate) {
    try {
      setIsPreLoad(true);
      setRetrievingLoadData(true);
      const hasPermission = await checkPreLoadAttendPermission();
      if (!hasPermission) {
        snackbar.show(<Text>Você não possui permissão para atender pré carga!</Text>, {
          type: 'error',
        });
        navigate('/cargas');
      }
      const { data: loadData } = await cooperplaceApi.get(`loads/${loadId}`);
      if (attendance.record ? !loadData?.preLoad || loadData?.travel?.id : !loadData?.preTravel?.id || loadData?.preTravel?.isAttended) {
        snackbar.show(<Text>Carga inválida!</Text>, { type: 'error' });
        navigate('/cargas');
      }
      const takerCurrency = currencyOptions.find((item) => item.value === loadData?.currency);

      await initFreightValues({
        rate,
        currency: takerCurrency,
        customData: {
          customer: {
            takerValue: {
              value: loadData?.takerValue,
            },
          },
        },
      });
      const negotiator = await preLoadNegotiator(loadData?.preTravel?.userCreated, currentUser);

      setData((old) => ({
        ...old,
        preLoadId: loadData?.id,
        client: {
          id: loadData?.taker?.id,
          social_name: loadData?.taker?.socialName,
          cgccpf: loadData?.taker?.cpfCnpj,
          label: `${loadData?.taker?.socialName} - ${loadData?.taker?.cpfCnpj}`,
          type: loadData?.taker?.type,
        },
        negotiator: negotiator ? [negotiator] : [],
        phone: negotiator?.phonenumber || '',
        taker_value: loadData?.takerValue,
        total_taker_value: loadData?.totalTakerValue,
        branchOffice: loadData?.branchOffice,
        selectedVehicles: loadData?.vehicleTypes?.map(item => ({
          id: item?.id,
          name: item?.name,
          qty_axes: item?.qtyAxes,
          qty_plates: item?.qtyPlates,
        })),
        selectedBodies: loadData?.vehicleBodyTypes?.map(item => ({
          id: item?.id,
          name: item?.name,
        })),
        selectedImplements: loadData?.vehicleImplementTypes?.map(item => ({
          id: item?.id,
          name: item?.name,
        })),
        costCenter: {
          id: loadData?.costCenter?.id,
          name: loadData?.costCenter?.name,
          business_id: loadData?.costCenter?.businessId,
          external_id: loadData?.costCenter?.externalId,
        },
        dueDate: moment(loadData?.dueDate, 'YYYY/MM/DDTHH:mm').format('DD/MM/YYYY HH:mm'),
        product: loadData?.product,
        observations: loadData?.comments,
        externalInvoiceNumber: loadData?.externalInvoiceNumber,
        clientOrderNumber: loadData?.clientOrderNumber,
        loadPublish: loadData?.loadPublish,
        searchDriverRadius: loadData?.searchDriverRadius ? loadData?.searchDriverRadius : '0',
        searchDriver: loadData?.searchDriver == 1 ? false : true,
        currency: takerCurrency,
        selectedDisposition: loadData?.disposition,
        weight: loadData?.loadWeight,
        origin: enrichPointForRouteMap(loadData?.loadOrigins[0], 'collect'),
        destinations: loadData?.loadDestinations?.map(dest => enrichPointForRouteMap(dest, dest.action)),
        riskManagers: loadData?.riskManagers,
        tracking: loadData?.riskManagers?.length > 0 ? true : false,
        palletNumber: loadData?.palletNumber,
      }));

      setDueDate(moment(loadData?.dueDate).format('DD/MM/YYYY HH:mm'));
      setSearchDriver(!!loadData?.searchDriver);
    } catch {
      setIsPreLoad(false);
      snackbar.show(<Text>Erro ao recuperar informações da pré carga</Text>, {
        type: 'error',
      });
    } finally {
      setRetrievingLoadData(false);
      setLoading(false);
    }
  }

  function enrichPointForRouteMap(point, action) {
    const normalized = (action || '').toLowerCase();
    const type =
      normalized === 'via'
        ? { id: 'via', name: 'Ponto intermediário' }
        : DELIVERY_TYPE_OPTIONS.find(item => item.id === normalized);
    return {
      ...point,
      arrivalTime: null,
      arrival_time: null,
      effectiveTime: null,
      effective_time: null,
      identifier: point.id || `point-${Date.now()}-${Math.random()}`,
      type: type,
      action: type,
      zip_code: point.zipCode,
      address: point.address || point.formattedAddress || '',
      formatted_address: point.formattedAddress || '',
      neighborhood: point.neighborhood || '',
      city: point.cityModel ? {
        id: point.cityModel.id,
        name: point.cityModel.name,
      } : {
        name: point.city,
      },
      cityId: point.cityId || point.city?.id || null,
      province: point.cityModel?.province?.uf || point.province,
      country: countryList.find(item => item.abbreviation === point.countrySlug) || defaultCountry,
      lat: point.lat,
      lng: point.lng,
      number: point.number || '',
      start_schedule: point.startSchedule ? moment(point.startSchedule).toISOString() : '',
      scheduled_time: point.scheduledTime ? moment(point.scheduledTime).toISOString() : '',
      client: point?.client?.id
        ? {
          id: point.client.id,
          social_name: point.client.socialName,
          cgccpf: point.client.cpfCnpj,
          label: `${point.client.socialName} - ${point.client.cpfCnpj}`,
        }
        : null,
    };
  }

  function showSnackbar(text, options, id) {
    snackbar.show(<Text id={id}> {text} </Text>, options);
  }

  async function handleClientChange(client) {
    if (client) {
      setClientAutomations(client.automations.flatMap((item) => item.automations));
    } else {
      setClientAutomations([]);
    }
  }

  async function handleAttemptToRegisterLoad() {

    if (errors?.negotiation && params?.clone_id) {
      return;
    }

    if (loadingGro) {
      snackbar.show(
        <Text>
          Aguarde o cálculo de pedágio da rota terminar para salvar a carga.
        </Text>,
        { type: 'warning' }
      );
      return;
    }

    setShowRouteErrors(true);

    const validRoutePoints = [
      data?.origin,
      ...(Array.isArray(data?.destinations) ? data.destinations : []),
    ].filter(
      point =>
        point?.type?.id !== 'via' &&
        point?.action?.id !== 'via' &&
        Number.isFinite(Number(point?.lat)) &&
        Number.isFinite(Number(point?.lng)),
    );

    try {
      const freightValues = await freightValuesRef?.current?.getValues();
      const replacementFreightValues =
        await freightValuesReplaceRef?.current?.getValues();
      if (attendance.error || attendance.accessPending) throw new Error(attendance.error || 'Aguarde a confirmação do acesso ao atendimento.');
      const saved = await handleCreation(
        {
          ...data,
          controlTower: attendance.record,
          searchDriver,
          extraFields,
          inputsExtraFields,
          transferExtraFields,
          discountsExtraFields,
          isPreloadWithGRO,
        },
        freightValues,
        replacementFreightValues,
        tollsPlazaInfos,
        setErrorsWithRouteDateErrors,
        showSnackbar,
        setLoading,
        (modalStatus) => {
          setShowModal(modalStatus);
          setResetRouteTrigger(prev => prev + 1);
        },
        setRegisteredLoad,
        isPreLoad
      );
      // 5724: pelo Kanban, a pré-carga completada segue para os Detalhes da carga com o contexto da carga.
      if (saved && attendance.record) {
        try {
          attendance.proceed(saved.next, `/cargas/${saved.id}`);
        } catch (error) {
          snackbar.show(<Text>{error.message}</Text>, { type: 'error' });
          attendance.back();
        }
      }
    } catch (error) {

      snackbar.show(
        <Text>
          {error?.response?.data?.message || 'Erro ao cadastrar carga!'}
        </Text>,
        { type: 'error' }
      );
    }
  }

  const getAvailablePolicies = async (clientId) => {
    try {
      const { data: policiesData } = await cooperplaceApi.get(`clients/${clientId}/policies`);
      const activePolicies = policiesData.filter((policy) => policy.active);

      const { data: operationsData } = await cooperplaceApi.get('policies/operations', {
        params: {
          policyIds: activePolicies.map((policy) => policy.id),
        },
      });

      const formatedOperations = operationsData.map((operation) => {
        return {
          value: operation.id,
          label: `${operation.policy.name} - ${operation.name}`,
          data: {
            operation,
          },
        };
      });

      setOperationOptions(formatedOperations);
    } catch (error) {
      snackbar.show(<Text>Erro ao buscar apólices e operações do cliente!</Text>, {
        type: 'error',
      });
    }
  };


  const getProductOptionsByPolicy = async (policyId, operationId) => {
    try {
      const { data: productsData } = await cooperplaceApi.get('products/forSelect', {
        params: {
          operationId,
          policyId,
        },
      });

      setData((old) => {
        return {
          ...old,
          preLoadPolicy: {
            ...old.preLoadPolicy,
            productsOptions: productsData,
            selectedProduct: old.preLoadPolicy?.selectedProduct || {
              name: old.product?.name,
              ncm: old.product?.ncm,
              id: old.product?.id,
            },
          },
        };
      });
    } catch (error) {
      //
    }
  };

  const isPreLoadWithGROProductDisabled = useMemo(
    () =>
      isPreloadWithGRO &&
      (!data?.preLoadPolicy?.productsOptions || data?.preLoadPolicy?.productsOptions?.length === 0),
    [isPreloadWithGRO, data?.preLoadPolicy?.productsOptions],
  );

  const isPreLoadWithGROVehicleDisabled = useMemo(() => {
    if (!isPreloadWithGRO) return false;
    return (
      (isPreloadWithGRO && !data?.preLoadPolicy?.selectedProduct) ||
      data?.preLoadPolicy?.vehiclesOptionsId?.length === 0 ||
      !data?.preLoadPolicy?.vehiclesOptionsId
    );
  }, [
    isPreloadWithGRO,
    data?.preLoadPolicy?.selectedProduct,
    data?.preLoadPolicy?.vehiclesOptionsId,
  ]);

  const isPreLoadWithGROCargoValueDisabled = useMemo(() => {
    if (!isPreloadWithGRO) return false;
    const includesApolicyVehicle = data?.selectedVehicles?.find((vehicle) =>
      data?.preLoadPolicy?.vehiclesOptionsId?.includes(vehicle.id),
    );

    return !(
      isPreloadWithGRO &&
      !isPreLoadWithGROProductDisabled &&
      !isPreLoadWithGROVehicleDisabled &&
      includesApolicyVehicle
    );
  }, [
    isPreLoadWithGROVehicleDisabled,
    isPreLoadWithGROProductDisabled,
    data?.preLoadPolicy?.vehiclesOptionsId,
    data?.selectedVehicles,
  ]);

  useEffect(() => {
    handleGetRate('USD');
    fetchCountries(setCountryList);
    setData((old) => ({
      ...old,
      externalInvoiceNumber: '',
      dueDate: moment().add(1, 'day').format('DD/MM/YYYY HH:mm'),
      taker_value: null,
      toll_value: null,
      discharge_value: null,
      gris: null,
      ad_valorem: null,
      charge_value: null,
      ferry: null,
      ICMS: null,
      advance_money_percentage: 0,
    }));
  }, []);

  useEffect(() => {
    if (data?.operationPreLoad?.data?.operation?.id && data?.preLoadPolicy?.id) {
      getProductOptionsByPolicy(
        data.operationPreLoad.data.operation.policy.id,
        data.operationPreLoad.data.operation.id,
      );
    }
  }, [data?.preLoadPolicy?.id, data?.operationPreLoad?.data?.operation?.id]);

  useEffect(() => {
    if (data.client?.id && data?.hasRoutes) {
      routeModal.open();
    }
  }, [data?.hasRoutes]);

  useEffect(() => {
    if (!data.client?.id) {
      setData((old) => ({ ...old, hasRoutes: false }));
    }
  }, [data?.client?.id]);

  useEffect(() => {
    if (isPreLoad && data?.client?.id) {
      getAvailablePolicies(data.client.id);
    }
  }, [isPreLoad, data?.client?.id]);

  useEffect(() => {
    if (
      !params.id &&
      !params.clone_id &&
      !location?.pathname.includes('gro') &&
      !location?.state?.clientData
    ) {
      snackbar.show(<Text>Acesso inválido!</Text>, { type: 'error' });
      navigate('/cargas');
    }
    if (!params.id && location?.state?.clientData) {
      setData((old) => ({
        ...old,
        client: location?.state?.clientData,
        isGROLoad: !!location?.pathname.includes('gro'),
      }));
    }
  }, [params, location]);

  useEffect(() => {
    if (!rateResponse) {
      return;
    }

    if (params?.id && countryList?.length > 0) {
      setRetrievingLoadData(true);
      handleFetchLoad(params?.id, rateResponse);
    } else if (params?.clone_id && countryList?.length > 0) {
      duplicateLoad(params?.clone_id, rateResponse);
    } else if (!freightValuesInitiated) {
      initFreightValues({
        rate: rateResponse,
      });
      setLoading(false);
    }
  }, [params, rateResponse, countryList, freightValuesInitiated]);

  const lastDestination = useMemo(() => {
    return data?.destinations?.length ? data?.destinations[data?.destinations?.length - 1] : null;
  }, [data?.destinations]);

  async function onChangeInsurancePropsFilter() {
    const insuranceValue = await updateInsuranceValue({
      document: data?.client?.cgccpf,
      container: data?.container,
      loadValue: data?.cargoValue,
      currency: data?.load_currency?.value,
      exchange: data?.exchange,
      originIbgeCode: data?.origin?.city?.ibge_code,
      originCityName: data?.origin?.city?.name,
      originState: data?.origin?.city?.province?.uf,
      originStateName: data?.origin?.city?.province?.name,
      originCountry: data?.origin?.country?.abbreviation,
      destinationIbgeCode: lastDestination?.city?.ibge_code,
      destinationCityName: lastDestination?.city?.name,
      destinationStateName: lastDestination?.city?.province?.name,
      destinationState: lastDestination?.city?.province?.uf,
      destinationCountry: lastDestination?.country?.abbreviation,
    });

    if (insuranceValue !== null && insuranceValue !== undefined) {
      await freightValuesRef?.current?.setInsuranceValueBenner(insuranceValue);
      await freightValuesReplaceRef?.current?.setInsuranceValueBenner(insuranceValue);
    }
  }

  useEffect(() => {
    if (!location?.pathname.includes('gro')) {
      onChangeInsurancePropsFilter();
    }
  }, [
    location,
    data?.cargoValue,
    data?.load_currency?.value,
    data?.exchange,
    data?.client?.cgccpf,
    data?.container,
    data?.origin?.country,
    data?.origin?.city,
    lastDestination?.city,
    lastDestination?.country,
  ]);

  const isNational = useMemo(() => {
    if (!data?.origin?.country || !lastDestination?.country) {
      return true;
    }

    return (
      data?.origin?.country?.abbreviation === 'br' &&
      lastDestination?.country?.abbreviation === 'br'
    );
  }, [data?.origin?.country?.abbreviation, lastDestination?.country?.abbreviation]);

  const cargoValueInReal = useMemo(() => {
    if (data?.load_currency?.value === 'BRL') {
      return data?.cargoValue;
    }

    return data?.convertedCargoValue;
  }, [data?.cargoValue, data?.load_currency?.value]);

  const validateRetroactive = useMemo(() => {
    if (!data?.costCenter) {
      return true;
    }

    return data?.costCenter?.limit_schedule;
  }, [data?.costCenter]);

  const routeMachineLoadCreated = useMemo(() => ({
    selectedVehicles: data?.selectedVehicles || [],
    selectedImplements: data?.selectedImplements || [],
    takerValue: data?.takerValue ?? 0,
  }), [
    data?.selectedVehicles,
    data?.selectedImplements,
    data?.takerValue,
  ]);

  function onChangeCustomerFields(updatedFields) {
    setData({
      ...data,
      takerValue: updatedFields?.takerValue?.value,
    });
  }

  const value = {
    data,
    setData,
    errors,
    setErrors,
    rateResponse,
    loadingRate,
    clientCardToggle,
    setClientCardToggle,
    inputsCardToggle,
    setInputsCardToggle,
    discountsCardToggle,
    setDiscountsCardToggle,
    transferCardToggle,
    setTransferCardToggle,
    extraFields,
    setExtraFields,
    inputsExtraFields,
    setInputsExtraFields,
    discountsExtraFields,
    setDiscountsExtraFields,
    transferExtraFields,
    setTransferExtraFields,
    negotiatedCardToggle,
    setNegotiatedCardToggle,
    retrievingLoadData,
    dueDate,
    setDueDate,
    searchDriver,
    setSearchDriver,
    isPreLoad,
    countryList,
    loadingGro,
    setLoadingGro,
    setShowModal,
    setRegisteredLoad,
    isPreloadWithGRO,
    isPreLoadWithGROProductDisabled,
    isPreLoadWithGROVehicleDisabled,
    isPreLoadWithGROCargoValueDisabled,
    loadingDuplicate
  };

  return (
    <ApplicationLayout
      title={`${data?.isGROLoad ? 'Cadastro de Carga com Apólice' : 'Cadastro de carga'
        }`}
      RightComponent={
        data?.isGROLoad ? (
          <Button
            variant="secondary"
            onClick={() => attendance.record || attendance.error ? attendance.back() : navigate('/cargas')}
            disabled={loading}
            id="button-gro-cancelar-cadastro"
          >
            <Text weight={500} color="black" type="regular">
              Cancelar
            </Text>
          </Button>
        ) : (
          <>
            <Button
              variant="secondary"
              onClick={() => attendance.record || attendance.error ? attendance.back() : navigate('/cargas')}
              disabled={loading}
              id="button-cancelar-carga"
            >
              <Text weight={500} color="black" type="regular">
                Cancelar
              </Text>
            </Button>
	            <Button
	              variant="success"
	              onClick={handleAttemptToRegisterLoad}
	              loading={loading || insuranceBennerLoading || loadingGro}
	              disabled={retrievingLoadData || loadingGro || (Boolean(attendance.error) || attendance.accessPending)}
	              id="button-salvar-carga"
	            >
              <Text weight={500} color="white" type="regular">
                Salvar carga
              </Text>
            </Button>
          </>
        )
      }
    >
      <AttendanceNotice attendance={attendance} busy={loading} />
      <Modal
        show={showModal}
        heading="Cadastro de cargas"
        body={
          <>
            <p>
              Carga <b id="label-carga-cadastrada-sucesso">{registeredLoad}</b> cadastrada com
              sucesso!
            </p>
          </>
        }
        closeButton={false}
        backdrop="static"
        size="lg"
        footer={
          <>
            <Button
              variant="white"
              outlined
              onClick={() => attendance.record || attendance.error ? attendance.back() : navigate('/cargas')}
              id="button-carga-ver-listagem"
            >
              <Text>Ver listagem</Text>
            </Button>
            <Button
              variant="primary"
              onClick={() => navigate(`/cargas/${registeredLoad}`)}
              id="button-carga-visualizar-carga"
            >
              <Text>Visualizar carga</Text>
            </Button>
            {hasPermissionToCreate && (
              <Button
                variant="success"
                onClick={() => {
                  if (isPreLoad) {
                    navigate('/pre-cargas/cadastrar');
                  } else {
                    navigate({
                      pathname: '/cargas',
                      state: {
                        openNewLoadModal: true,
                      },
                    });
                  }
                }}
                id="button-carga-nova-carga"
              >
                <Text>Nova carga</Text>
              </Button>
            )}
          </>
        }
      />
      <AttemptRegisterLoad
        isOpen={attemptRegisterLoadModal.isOpen}
        onClose={() => attemptRegisterLoadModal.close()}
      />

      <AddLoadProvider value={value}>
        {data?.isGROLoad ? (
          <RegisterLoadGRO />
        ) : (
          <>
            <RouteModal
              isOpen={routeModal.isOpen}
              onClose={routeModal.close}
              client={data.client}
            />
            <Row xs={12} className="row-eq-height">
              <Col xs={12} md={6}>
                <Row>
                  <Col xs={12}>
                    <LoadData
                      operationOptions={operationOptions}
                      onClientChange={handleClientChange}
                    />
                  </Col>
                </Row>
              </Col>
              <Col xs={12} md={6}>
                <Row className="row-eq-height h-100">
                  <Col xs={12}>
                    <Vehicle />
                  </Col>
                  <Col xs={12}>
                    <Monitoring />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Col xs={12} className="mt-3">
              <TravelRouteCard
                points={points}
                externalTotalDistanceInKm={data?.totalDistanceInKm || 0}
                polyline={data?.polylineRoute ? data?.polylineRoute : null}
                polylineWaypoints={data?.polylineWaypoints ? data?.polylineWaypoints : null}
                externalLoading={retrievingLoadData}
                externalResetChangesTrigger={resetRouteTrigger}
                onChangeRoute={onChangeRoute}
                onChangeAddress={onChangeAddress}
                validateRetroactive={validateRetroactive}
                loadCreated={routeMachineLoadCreated}
                takerValue={data?.takerValue}
                showRouteErrors={showRouteErrors}
                tollsPlazaInfos={tollsPlazaInfos}
                setTollsPlazaInfos={setTollsPlazaInfos}
                setTollsPlazaLoadingGro={setLoadingGro}
                alwaysEditable
                onSavePoints={onSaveMachineRoute}
                destinationsError={destinationsError}
              />
            </Col>
            <Row>
              <FreightValues
                isReplacement={data?.isReplacement}
                totalKm={tollsPlazaInfos?.totalKm}
                onChangeCustomerFields={onChangeCustomerFields}
                isNational={isNational}
                freightValuesRef={freightValuesRef}
                freightValuesReplaceRef={freightValuesReplaceRef}
                cargoValue={cargoValueInReal}
                loadingDuplicate={loadingDuplicate}
              />
            </Row>
            <Row>
              <Automations clientAutomations={clientAutomations} />
            </Row>
          </>
        )}
      </AddLoadProvider>
    </ApplicationLayout>
  );
}

export default function LoadRegisterProviders() {
  return (
    <InsuranceValueContextProvider>
      <LoadRegister />
    </InsuranceValueContextProvider>
  );
}
